module.exports = __webpack_public_path__ + "static/media/angular.ce65f79b.png";